import { render, staticRenderFns } from "./DenyOnlinePayments.vue?vue&type=template&id=6a15907a&"
import script from "./DenyOnlinePayments.vue?vue&type=script&lang=js&"
export * from "./DenyOnlinePayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports